// ./SchoolCode/SchoolCodeForm/index.js
import React, { Component } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import AdmissionApi, { acz } from "../../../../Services/AdmissionApi"; // adjust path if needed

class SchoolCodeForm extends Component {
  constructor(props) {
    super(props);
    const data = props.data || {};
    this.state = {
      id: data.id || null,
      school_name: data.school_name || "",
      school_code: data.school_code || "",
      errors: {},
      saving: false,
    };

    this.admissionsService = new AdmissionApi();
    // ensure headers use your acz credentials
    this.admissionsService.setObj({ clientId: acz.clientId, appId: acz.appId });
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  validate = () => {
    const errors = {};
    const schoolName = (this.state.school_name || "").trim();
    const schoolCode = (this.state.school_code || "").trim();

    if (!schoolName) errors.school_name = "School name is required";
    if (!schoolCode) errors.school_code = "School code is required";

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.validate()) return;

    this.setState({ saving: true });

    const { id } = this.state;
    const payload = {
      school_name: (this.state.school_name || "").trim(),
      school_code: (this.state.school_code || "").trim(),
    };

    if (id) {
      // PUT /v1/school-codes/:id
      this.admissionsService.updateStudent(
        (res) => {
          this.setState({ saving: false });
          if (res.status === 200) {
            toast.success("School code updated successfully.");
            this.props.updateRoutePage("school-code");
          } else {
            toast.error(res.data.message || "Update failed.");
          }
        },
        "v1/school-codes",
        id,
        payload
      );
      return;
    }

    // POST /v1/school-codes
    this.admissionsService.createNew(
      (res) => {
        this.setState({ saving: false });
        if (res.status === 200 || res.status === 201) {
          toast.success("School code created successfully.");
          this.props.updateRoutePage("school-code");
        } else {
          toast.error(res.data.message || "Creation failed.");
        }
      },
      payload,
      "v1/school-codes"
    );
  };

  cancel = () => this.props.updateRoutePage("school-code");

  render() {
    const { school_name, school_code, errors, saving } = this.state;

    return (
      <section className="dash-alerts">
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <label className="control-label">School Name</label>
            <input
              name="school_name"
              type="text"
              className="form-control"
              value={school_name}
              onChange={this.handleChange}
            />
            {errors.school_name && <span className="text-danger">{errors.school_name}</span>}
          </div>

          <div className="form-group">
            <label className="control-label">School Code</label>
            <input
              name="school_code"
              type="text"
              className="form-control"
              value={school_code}
              onChange={this.handleChange}
            />
            {errors.school_code && <span className="text-danger">{errors.school_code}</span>}
          </div>

          <div className="mt-3">
            <button type="submit" className="btn btn--primary" disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>
            <button type="button" onClick={this.cancel} className="btn btn--default ml-2">
              Cancel
            </button>
          </div>
        </form>
      </section>
    );
  }
}

SchoolCodeForm.propTypes = {
  data: PropTypes.object,
  updateRoutePage: PropTypes.func.isRequired,
};

export default SchoolCodeForm;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/SchoolCode/SchoolCodeForm/index.js
 **/